import React, { useMemo } from 'react'
// eslint-disable-next-line no-restricted-imports
import { Alert, AlertProps } from 'antd'
import ExclamationCircleFilled from '@ant-design/icons/ExclamationCircleFilled'
export type { AlertProps }
import classNames from 'classnames'
import styles from './index.less'

/**
 * https://www.figma.com/design/Fo9eRjBLrsRAvFBiNO9UXU/%E8%81%9A%E6%B0%B4%E6%BD%AD-%E4%BE%9B%E5%BA%94%E9%93%BE?node-id=29-42&m=dev
 */
export default (props: AlertProps) => {
    const { className, type, ...restProps } = props
    const resetClassType = useMemo(() => {
        switch (type) {
            case 'success':
                return styles.resetSuccess
            case 'warning':
                return styles.resetWarning
            case 'info':
                return styles.resetInfo
            case 'error':
                return styles.resetError
            default:
                return styles.resetInfo
        }
    }, [type])

    const resetIcon = useMemo(() => {
        switch (type) {
            case 'error':
                return <ExclamationCircleFilled />
            default:
                return undefined
        }
    }, [type])

    return (
        <Alert
            type={type}
            icon={resetIcon}
            className={classNames(styles.resetAlert, resetClassType, className)}
            {...restProps}
        />
    )
}
